import React from 'react';
import Weather from "./Weather";
import ToDo from "./ToDo";
import Time from "./Time";
import CountdownWidget from "./Countdown";
import TrainSchedule from "./Septa";
import Shortcuts from "./Shortcuts";
import Word from "./Word";

const Home = () => {
    return (
        <main>
            <h1 className="welcome">Welcome Jacquelyn!</h1>
            <section className="top-widgets">
                <div className="weather parent-center">
                    <Weather/>
                </div>
                <div className="countdown parent-center">
                    <CountdownWidget />
                </div>
                <div className="time">
                    <Time/>
                </div>
            </section>
            <section className="top-widgets">
                <div className="word parent-center">
                    <Word />
                </div>
                <div className="shortcuts parent-center">
                    <Shortcuts />
                </div>
            </section>
            <section>
                <div className="todo">
                    <ToDo/>
                </div>
            </section>
            <section>
                <div className="train">
                    <TrainSchedule/>
                </div>
            </section>
            
        </main>
    )
}

export default Home;